var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2493 2.25H3.74928C2.92086 2.25 2.24928 2.92157 2.24928 3.75V14.25C2.24928 15.0784 2.92086 15.75 3.74928 15.75H14.2493C15.0777 15.75 15.7493 15.0784 15.7493 14.25V3.75C15.7493 2.92157 15.0777 2.25 14.2493 2.25Z",
    stroke: "#FF6B00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.37366 7.5C6.99498 7.5 7.49866 6.99632 7.49866 6.375C7.49866 5.75368 6.99498 5.25 6.37366 5.25C5.75234 5.25 5.24866 5.75368 5.24866 6.375C5.24866 6.99632 5.75234 7.5 6.37366 7.5Z",
    stroke: "#FF6B00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.748 11.25L11.998 7.5L3.74805 15.75",
    stroke: "#FF6B00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgImage;